import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Seo } from '@/components/generals/seo'

// The hero runs a live WebGL canvas, so it mounts client-side only. The cream
// fallback matches the section background to avoid any flash before it paints.
const CremaHero = dynamic(() => import('@/components/landing/crema/crema-hero'), {
    ssr: false,
    loading: () => <div style={{ minHeight: '100svh', background: '#F2EDE2' }} />
})

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Order Ahead, Skip the Line'
                description='Crema is the order-ahead coffee app. Skip the line, save your favorites, pay in the app, and earn a free drink every twelve.'
            />

            <main>
                <CremaHero />
            </main>
        </>
    )
}

export default Home
